<div class="user">
  <craft-user-icon class="icon" [user]="user"></craft-user-icon>
  <div class="ellipsis">
    <div [matTooltip]="user | fullName" [matTooltipShowDelay]="1000" class="name ellipsis">{{ user | fullName }}</div>
    <div [matTooltip]="user.email || ''" [matTooltipShowDelay]="1000" class="email ellipsis">{{ user.email }}</div>
  </div>
</div>
